export const ShelfTheme = {
  colors: { primary: "#002C98" },
  fontSize: {
    xxxl: "48px",
    xxl: "36px",
    xl: "32px",
    lg: "24px",
    md: "18px",
    base: "16px",
    sm: "14px",
    xm: "13px",
    xs: "12px",
    xxs: "11px"
  },
  font: {
    superBold: "600",
    bold: "500",
    semiBold: "450",
    regular: "400"
  }
}
